import { getApplication } from 'shared/redux/applicationSlice';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  plantType: '',
  subType: '',
  registrationType: '',
  manufacturer: '',
  modelNameOrNumber: '',
  yearOfDesign: '',
  alterationDetails: undefined,
  plantSpecificDetails: undefined,
  isCompleted: false,
};

const plantDesignSlice = createSlice({
  name: 'plantDesign',
  initialState,
  reducers: {
    storePlantDesignDetails(state, action) {
      const designDetails = action.payload;
      return designDetails;
    },
    resetPlantDesignDetails(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantDesign };
      });
  },
});

export const { storePlantDesignDetails, resetPlantDesignDetails } = plantDesignSlice.actions;
export const plantDesignReducer = plantDesignSlice.reducer;
